import GlobalStyles from '@mui/material/GlobalStyles';
import React from 'react';

const PREFIX = 'WAMuiChipInput';

export const chipInputClasses = {
  root: `${PREFIX}-root`,
  inputRoot: `${PREFIX}-inputRoot`,
  input: `${PREFIX}-input`,
  chipContainer: `${PREFIX}-chipContainer`,
  outlined: `${PREFIX}-outlined`,
  standard: `${PREFIX}-standard`,
  filled: `${PREFIX}-filled`,
  labeled: `${PREFIX}-labeled`,
  label: `${PREFIX}-label`,
  labelShrink: `${PREFIX}-labelShrink`,
  helperText: `${PREFIX}-helperText`,
  focused: `${PREFIX}-focused`,
  disabled: `${PREFIX}-disabled`,
  underline: `${PREFIX}-underline`,
  error: `${PREFIX}-error`,
  chip: `${PREFIX}-chip`,
  marginDense: `${PREFIX}-marginDense`,
};

const c = chipInputClasses;

const chipInputGlobalStyles = theme => {
  const light = theme.palette.mode === 'light';
  const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';

  return {
    [`.${c.inputRoot}`]: {
      display: 'inline-flex',
      flexWrap: 'wrap',
      flex: 1,
      marginTop: 0,
      minWidth: '70px',
      [`&.${c.outlined},&.${c.filled}`]: {
        boxSizing: 'border-box',
      },
      [`&.${c.outlined}`]: {
        paddingTop: '14px',
      },
      [`&.${c.filled}`]: {
        paddingTop: '28px',
      },
    },
    [`.${c.input}`]: {
      display: 'inline-block',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      appearance: 'none',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)',
      float: 'left',
      flex: 1,
    },
    [`.${c.chipContainer}`]: {
      display: 'flex',
      flexFlow: 'row wrap',
      cursor: 'text',
      marginBottom: '-2px',
      minHeight: '40px',
      [`&.${c.labeled}.${c.standard}`]: {
        marginTop: '18px',
      },
    },
    [`.${c.outlined} input`]: {
      height: '16px',
      paddingTop: '4px',
      paddingBottom: '12px',
      marginTop: '4px',
      marginBottom: '4px',
    },
    [`.${c.filled} input`]: {
      height: '22px',
      marginBottom: '4px',
      marginTop: '4px',
      paddingTop: 0,
    },
    [`.${c.marginDense} .${c.filled} input`]: {
      height: '26px',
    },
    [`.${c.label}`]: {
      top: '4px',
      [`&.${c.outlined}:not(.${c.labelShrink})`]: {
        top: '2px',
        [`.${c.marginDense} &`]: {
          top: '5px',
        },
      },
      [`&.${c.filled}:not(.${c.labelShrink})`]: {
        top: '15px',
        [`.${c.marginDense} &`]: {
          top: '20px',
        },
      },
    },
    [`.${c.labelShrink}`]: {
      top: 0,
    },
    [`.${c.helperText}`]: {
      marginBottom: '-20px',
    },
    [`.${c.underline}`]: {
      '&:after': {
        borderBottom: `2px solid ${theme.palette.primary[light ? 'dark' : 'light']}`,
        left: 0,
        bottom: 0,
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut,
        }),
        pointerEvents: 'none',
      },
      [`&.${c.focused}:after`]: {
        transform: 'scaleX(1)',
      },
      [`&.${c.error}:after`]: {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)',
      },
      '&:before': {
        borderBottom: `1px solid ${bottomLineColor}`,
        left: 0,
        bottom: 0,
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter,
        }),
        pointerEvents: 'none',
      },
      [`&:hover:not(.${c.disabled}):not(.${c.focused}):not(.${c.error}):before`]: {
        borderBottom: `2px solid ${theme.palette.text.primary}`,
        '@media (hover: none)': {
          borderBottom: `1px solid ${bottomLineColor}`,
        },
      },
      [`&.${c.disabled}:before`]: {
        borderBottomStyle: 'dotted',
      },
    },
    [`.${c.error}:after`]: {
      backgroundColor: theme.palette.error.main,
      transform: 'scaleX(1)',
    },
    [`.${c.chip}`]: {
      margin: '0 8px 8px 0',
      float: 'left',
    },
  };
};

export const ChipInputGlobalStyles = () => <GlobalStyles styles={chipInputGlobalStyles} />;
